import { useState, useEffect } from 'react';

const announcements = [
  { id: 1, text: 'Entrega 24/72 H', link: 'Envío gratis en pedidos +50€' },
  { id: 2, text: '🎁 OFERTAS ESPECIALES', link: 'Descuentos hasta 40%' },
  { id: 3, text: '✨ NUEVAS MARCAS', link: 'Luna Moon, DNKA, Fox' }
];

export default function AnnouncementBar() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % announcements.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-white text-stone-900 py-2.5 text-center text-sm border-b border-stone-200">
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-center gap-2">
        <span className="font-semibold">{announcements[currentIndex].text}</span>
        <span className="text-stone-400">|</span>
        <span className="text-stone-500">{announcements[currentIndex].link}</span>
      </div>
    </div>
  );
}
